import { createSelector } from 'reselect';
import { generateUnassignedAssignment } from './helpers';
import { destructureAssignmentHashKey } from '../status-cell/helpers';

const getIsAssigningAssignments = state => state.gatewaysReducer.isAssigningAssignments;
const getIsUnAssigningAssignments = state => state.gatewaysReducer.isUnAssigningAssignments;

export const getAssignments = state => state.entitiesReducer.assignments;
export const getSelectedAssignmentHashKeys = state => state.UPFAssignReducer.selectedAssignmentHashKeys;

export const groupAssignAndUnAssignAssignmentsSelector = createSelector(
  [getSelectedAssignmentHashKeys, getAssignments],
  (selectedAssignmentHashKeys, assignments) => {
    const assignmentsToAssign = [];
    const assignmentsToUnAssign = [];

    const keys = Object.keys(selectedAssignmentHashKeys);
    const selectedCellsCount = keys.length;

    keys.forEach(key => {
      const selectedAssignment = selectedAssignmentHashKeys[key];
      const { studentId, learningJourneyId } = selectedAssignment;
      const assignment = assignments[key];
      const { currentAssignmentId } = assignment || {};

      if (currentAssignmentId) {
        const generatedAssignmentToUnassign = generateUnassignedAssignment({
          learningJourneyId,
          assignmentId: currentAssignmentId,
          studentUserProfileId: studentId
        });

        assignmentsToUnAssign.push(generatedAssignmentToUnassign);
      }

      assignmentsToAssign.push({
        studentUserProfileId: studentId,
        learningJourneyId
      });
    });

    return { assignmentsToAssign, assignmentsToUnAssign, selectedCellsCount };
  }
);

export const selectAllAssignments = createSelector([getAssignments], assignments => {
  const allAssignments = [];
  const keys = Object.keys(assignments);
  keys.forEach(key => {
    const { currentAssignmentId } = assignments[key];
    const { studentId } = destructureAssignmentHashKey(key);

    if (currentAssignmentId !== null) {
      const generatedAssignmentToUnassign = generateUnassignedAssignment({
        assignmentId: currentAssignmentId,
        studentUserProfileId: studentId
      });

      allAssignments.push(generatedAssignmentToUnassign);
    }
  });

  return allAssignments;
});

export const selectIsAssigningOrUnAssigning = createSelector(
  [getIsAssigningAssignments, getIsUnAssigningAssignments],
  (isAssigningAssignments, isUnAssigningAssignments) => isAssigningAssignments || isUnAssigningAssignments
);

export const selectHasAssignments = createSelector(
  [getAssignments],
  assignments => Object.keys(assignments).length > 0
);



// WEBPACK FOOTER //
// ./components/footer/selectors.js